import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App.tsx";
import { captureReferralOnLand } from "./conversion/captureReferralOnLand.ts";
import "./styles/tokens.css";
import "./styles/globals.css";
import "./styles/skeletons.css";
import "./styles/exchange.css";
import "./styles/fair-price.css";
import "./styles/vault.css";
import "./styles/watchlist.css";
import "./styles/sika.css";
import "./styles/slip-extractor.css";
import "./styles/pitch.css";
import "./styles/singles.css";
import "./styles/rollover.css";
import "./styles/powerball.css";
import "./styles/ladder.css";
import "./styles/owl.css";
import "./styles/reports.css";
import "./styles/audit.css";
import "./styles/knowledge.css";
import "./styles/landing.css";
import "./styles/free-tier.css";
import "./styles/super-acca.css";
import "./styles/intl-acca.css";
import "./styles/intl-acca-extended.css";
import "./styles/tennis.css";
import "./styles/basketball.css";
import "./styles/international.css";
import "./styles/football-products.css";

// Phase JB.3b — capture ?ref=CODE before React renders. Anon-safe.
captureReferralOnLand();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("STRIKZA: #root element missing in index.html");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
